import { DialogSurface, DialogBody, makeStyles } from "@fluentui/react-components";
import React from "react";

interface Props {
    children: React.ReactNode;
}

const useStyles = makeStyles({
    dialogSurface: {
        top: "-20%",
    },
    dialogBody: {
        display: "flex",
        flexDirection: "column",
    }
});

export default function AssignmentDialog({children}: Props) {    
    const styles = useStyles();

    return (
       <DialogSurface className={styles.dialogSurface}>
            <DialogBody className={styles.dialogBody}>
                {children}
            </DialogBody>
        </DialogSurface>
    );
}
